// extracted by mini-css-extract-plugin
module.exports = {"bio":"person_bio__3ofvN","title":"person_title__3bnv_","name":"person_name__Ko9nT","image":"person_image__deujO","element":"person_element__17wh4"};